import { useCurrentEdition } from "./use-current-edition";
import { useDeepDives } from "./use-deep-dives";

export const useCurrentEditionDeepDives = () => {
  const currentEdition = useCurrentEdition();
  return useDeepDives().filter(page => page.badge === currentEdition?.name);
}